/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

// @ts-ignore
function kRV_ATPQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery(
        'KRV_ATP',
        'KRV_ATPLeadTimePropertiesDate',
        DataServiceEntities.KRV_ATPLeadTimePropertiesDateExtensionClass,
        key
    );
}

export function createKRV_GetATPLeadTimeWithDateInput(itemId: string, requestedDate: string): IDataServiceRequest {
    const query = kRV_ATPQuery();
    return query.createDataServiceRequestForOperation(
        'KRV_GetATPLeadTimeWithDate',
        true,
        DataServiceEntities.KRV_ATPLeadTimePropertiesDateExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IKRV_ATPLeadTimePropertiesDate' },
        { itemId: itemId, requestedDate: requestedDate }
    );
}

export function kRV_GetATPLeadTimeWithDateAsync(
    context: IContext,
    itemId: string,
    requestedDate: string
): AsyncResult<DataServiceEntities.IKRV_ATPLeadTimePropertiesDate> {
    const request = createKRV_GetATPLeadTimeWithDateInput(itemId, requestedDate);
    return callActionOrExecute<DataServiceEntities.IKRV_ATPLeadTimePropertiesDate>(request, context.callerContext);
}

export function createKRV_GetATPLeadTimeWithQuantityInput(
    kRVATPLeadTimeQuantity: DataServiceEntities.IKRV_ATPLeadTimePropertiesQuantityRequestEntity[]
): IDataServiceRequest {
    const query = kRV_ATPQuery();
    return query.createDataServiceRequestForOperation(
        'KRV_GetATPLeadTimeWithQuantity',
        true,
        DataServiceEntities.KRV_GetATPLeadTimeResponseQuantityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IKRV_GetATPLeadTimeResponseQuantity' },
        { KRVATPLeadTimeQuantity: kRVATPLeadTimeQuantity }
    );
}

export function kRV_GetATPLeadTimeWithQuantityAsync(
    context: IContext,
    kRVATPLeadTimeQuantity: DataServiceEntities.IKRV_ATPLeadTimePropertiesQuantityRequestEntity[]
): AsyncResult<DataServiceEntities.IKRV_GetATPLeadTimeResponseQuantity> {
    const request = createKRV_GetATPLeadTimeWithQuantityInput(kRVATPLeadTimeQuantity);
    return callActionOrExecute<DataServiceEntities.IKRV_GetATPLeadTimeResponseQuantity>(request, context.callerContext);
}

export function createKRV_GetMultipleATPLeadTimeDateInput(
    kRVATPLeadTimeDate: DataServiceEntities.IKRV_ATPLeadTimePropertiesDateRequestEntity[]
): IDataServiceRequest {
    const query = kRV_ATPQuery();
    return query.createDataServiceRequestForOperation(
        'KRV_GetMultipleATPLeadTimeDate',
        true,
        DataServiceEntities.KRV_GetMultipleATPLeadTimeResponseDateExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IKRV_GetMultipleATPLeadTimeResponseDate' },
        { KRVATPLeadTimeDate: kRVATPLeadTimeDate }
    );
}

export function kRV_GetMultipleATPLeadTimeDateAsync(
    context: IContext,
    kRVATPLeadTimeDate: DataServiceEntities.IKRV_ATPLeadTimePropertiesDateRequestEntity[]
): AsyncResult<DataServiceEntities.IKRV_GetMultipleATPLeadTimeResponseDate> {
    const request = createKRV_GetMultipleATPLeadTimeDateInput(kRVATPLeadTimeDate);
    return callActionOrExecute<DataServiceEntities.IKRV_GetMultipleATPLeadTimeResponseDate>(request, context.callerContext);
}

// @ts-ignore
function kRV_CustomerBalanceQuery(dataAreaId?: string): DataServiceQuery {
    const key = dataAreaId ? { DataAreaId: dataAreaId } : null;
    return new DataServiceQuery('KRV_CustomerBalance', 'KRV_CustomerBalance', DataServiceEntities.KRV_CustomerBalanceExtensionClass, key);
}

export function createKRV_GetBalanceInput(customerAccount: string, dataAreaId: string): IDataServiceRequest {
    const query = kRV_CustomerBalanceQuery();
    return query.createDataServiceRequestForOperation(
        'KRV_GetBalance',
        true,
        DataServiceEntities.KRV_CustomerBalanceResponseEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IKRV_CustomerBalanceResponseEntity' },
        { customerAccount: customerAccount, DataAreaId: dataAreaId }
    );
}

export function kRV_GetBalanceAsync(
    context: IContext,
    customerAccount: string,
    dataAreaId: string
): AsyncResult<DataServiceEntities.IKRV_CustomerBalanceResponseEntity> {
    const request = createKRV_GetBalanceInput(customerAccount, dataAreaId);
    return callActionOrExecute<DataServiceEntities.IKRV_CustomerBalanceResponseEntity>(request, context.callerContext);
}

// @ts-ignore
function kRV_BillingAddressQuery(id?: string): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery(
        'KRV_BillingAddress',
        'KRV_AddressResponseEntity',
        DataServiceEntities.KRV_AddressResponseEntityExtensionClass,
        key
    );
}

export function createKRV_GetAddressInput(queryResultSettings: IQueryResultSettings, customerAccountNumber: string): IDataServiceRequest {
    const query = kRV_BillingAddressQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'KRV_GetAddress',
        true,
        DataServiceEntities.KRV_AddressEntityExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IKRV_AddressEntity' },
        { customerAccountNumber: customerAccountNumber }
    );
}

export function kRV_GetAddressAsync(
    context: IContext,
    customerAccountNumber: string
): AsyncResult<DataServiceEntities.IKRV_AddressEntity[]> {
    const request = createKRV_GetAddressInput(context.queryResultSettings || {}, customerAccountNumber);
    return callActionOrExecute<DataServiceEntities.IKRV_AddressEntity[]>(request, context.callerContext);
}

// @ts-ignore
function kRV_ProspectQuery(prospectEmail?: string): DataServiceQuery {
    const key = prospectEmail ? { ProspectEmail: prospectEmail } : null;
    return new DataServiceQuery('KRV_Prospect', 'KRV_ProspectProperties', DataServiceEntities.KRV_ProspectPropertiesExtensionClass, key);
}

export function createKRV_GetProspectStatusInput(email: string): IDataServiceRequest {
    const query = kRV_ProspectQuery();
    return query.createDataServiceRequestForOperation(
        'KRV_GetProspectStatus',
        true,
        DataServiceEntities.KRV_ProspectPropertiesExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IKRV_ProspectProperties' },
        { email: email }
    );
}

export function kRV_GetProspectStatusAsync(context: IContext, email: string): AsyncResult<DataServiceEntities.IKRV_ProspectProperties> {
    const request = createKRV_GetProspectStatusInput(email);
    return callActionOrExecute<DataServiceEntities.IKRV_ProspectProperties>(request, context.callerContext);
}

// @ts-ignore
function kRV_CMSDocumentsQuery(fileName?: string): DataServiceQuery {
    const key = fileName ? { FileName: fileName } : null;
    return new DataServiceQuery('KRV_CMSDocuments', 'KRV_CMSDocument', DataServiceEntities.KRV_CMSDocumentExtensionClass, key);
}

export function createKRV_SaveCMSDocumentInput(kRV_CMSDocument: DataServiceEntities.IKRV_CMSDocument): IDataServiceRequest {
    const query = kRV_CMSDocumentsQuery();
    return query.createDataServiceRequestForOperation(
        'KRV_SaveCMSDocument',
        true,
        DataServiceEntities.KRV_SaveCMSDocumentResponseEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IKRV_SaveCMSDocumentResponseEntity' },
        { kRV_CMSDocument: kRV_CMSDocument }
    );
}

export function kRV_SaveCMSDocumentAsync(
    context: IContext,
    kRV_CMSDocument: DataServiceEntities.IKRV_CMSDocument
): AsyncResult<DataServiceEntities.IKRV_SaveCMSDocumentResponseEntity> {
    const request = createKRV_SaveCMSDocumentInput(kRV_CMSDocument);
    return callActionOrExecute<DataServiceEntities.IKRV_SaveCMSDocumentResponseEntity>(request, context.callerContext);
}

export function createKRV_DownloadCMSDocumentInput(
    queryResultSettings: IQueryResultSettings,
    itemNumber: string,
    oun: string
): IDataServiceRequest {
    const query = kRV_CMSDocumentsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'KRV_DownloadCMSDocument',
        true,
        DataServiceEntities.KRV_DownloadCMSDocumentResponseEntityExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IKRV_DownloadCMSDocumentResponseEntity' },
        { itemNumber: itemNumber, oun: oun }
    );
}

export function kRV_DownloadCMSDocumentAsync(
    context: IContext,
    itemNumber: string,
    oun: string
): AsyncResult<DataServiceEntities.IKRV_DownloadCMSDocumentResponseEntity[]> {
    const request = createKRV_DownloadCMSDocumentInput(context.queryResultSettings || {}, itemNumber, oun);
    return callActionOrExecute<DataServiceEntities.IKRV_DownloadCMSDocumentResponseEntity[]>(request, context.callerContext);
}

// @ts-ignore
function kRV_NewsLetterQuery(emailAddress?: string): DataServiceQuery {
    const key = emailAddress ? { EmailAddress: emailAddress } : null;
    return new DataServiceQuery(
        'KRV_NewsLetter',
        'KRV_SubscribeNewsLetter',
        DataServiceEntities.KRV_SubscribeNewsLetterExtensionClass,
        key
    );
}

export function createKRV_SubscribeNewsLetterInput(subscribeNewsLetter: DataServiceEntities.IKRV_SubscribeNewsLetter): IDataServiceRequest {
    const query = kRV_NewsLetterQuery();
    return query.createDataServiceRequestForOperation(
        'KRV_SubscribeNewsLetter',
        true,
        DataServiceEntities.KRV_SubscribeNewsLetterResponseEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IKRV_SubscribeNewsLetterResponseEntity' },
        { subscribeNewsLetter: subscribeNewsLetter }
    );
}

export function kRV_SubscribeNewsLetterAsync(
    context: IContext,
    subscribeNewsLetter: DataServiceEntities.IKRV_SubscribeNewsLetter
): AsyncResult<DataServiceEntities.IKRV_SubscribeNewsLetterResponseEntity> {
    const request = createKRV_SubscribeNewsLetterInput(subscribeNewsLetter);
    return callActionOrExecute<DataServiceEntities.IKRV_SubscribeNewsLetterResponseEntity>(request, context.callerContext);
}

// @ts-ignore
function kRV_CalendarOffDaysQuery(fromDate?: Date): DataServiceQuery {
    const key = fromDate ? { FromDate: fromDate } : null;
    return new DataServiceQuery(
        'KRV_CalendarOffDays',
        'KRV_CalendarOffDaysEntity',
        DataServiceEntities.KRV_CalendarOffDaysEntityExtensionClass,
        key
    );
}

export function createFetchInput(queryResultSettings: IQueryResultSettings, requestedDate: string): IDataServiceRequest {
    const query = kRV_CalendarOffDaysQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'Fetch',
        true,
        '',
        'true',
        { bypassCache: 'get', returnEntity: '' },
        { requestedDate: requestedDate }
    );
}

export function fetchAsync(context: IContext, requestedDate: string): AsyncResult<Date[]> {
    const request = createFetchInput(context.queryResultSettings || {}, requestedDate);
    return callActionOrExecute<Date[]>(request, context.callerContext);
}

// @ts-ignore
function kRV_SalesRepresentativeQuery(customerAccount?: string): DataServiceQuery {
    const key = customerAccount ? { CustomerAccount: customerAccount } : null;
    return new DataServiceQuery(
        'KRV_SalesRepresentative',
        'KRV_SalesRepresentative',
        DataServiceEntities.KRV_SalesRepresentativeExtensionClass,
        key
    );
}

export function createKRV_GetSalesRepresentativeInput(customerAccount: string): IDataServiceRequest {
    const query = kRV_SalesRepresentativeQuery();
    return query.createDataServiceRequestForOperation(
        'KRV_GetSalesRepresentative',
        true,
        DataServiceEntities.KRV_SalesRepresentativeResponseEntityExtensionClass,
        'false',
        { bypassCache: 'put', returnEntity: 'DataServiceEntities.IKRV_SalesRepresentativeResponseEntity' },
        { customerAccount: customerAccount }
    );
}

export function kRV_GetSalesRepresentativeAsync(
    context: IContext,
    customerAccount: string
): AsyncResult<DataServiceEntities.IKRV_SalesRepresentativeResponseEntity> {
    const request = createKRV_GetSalesRepresentativeInput(customerAccount);
    return callActionOrExecute<DataServiceEntities.IKRV_SalesRepresentativeResponseEntity>(request, context.callerContext);
}
